/**
 * Intent-related cross-stack constants.
 *
 * Single source of truth for sentinel strings the FE and BE both recognize.
 * Defined in TypeScript and mirrored in Rust (see
 * `backend/shared/src/enricher/intent/mod.rs::PICKUP_ALL_SENTINEL`); changing
 * one without the other breaks the FE→BE handshake silently.
 */

/**
 * Sentinel value placed in `IntentHint.item_name` by the `/pickup all` slash
 * command short-circuit. The backend's `enrich_pickup` recognizes this string
 * and routes to the deterministic handler that picks up every lootable item
 * in the current scene. No real item is named this — the underscore-flanked
 * form is intentionally chosen to avoid collision with any plausible
 * D&D item name.
 */
export const PICKUP_ALL_SENTINEL = '__all__';
